import React from 'react';
import Label from "../../UI/Label";
import { trackPropTypes, tracksWidth } from "../../../config/defaults";
import { getLabelColorByStateAndDifficulty, getTrackColorByStateAndDifficulty } from "../../../helpers/map";
import { TRACK_DIFFICULTY_BLUE } from "../../../config/constants";
import TrackArrow from "../../UI/TrackArrow";

const TrackSBlue = ({ state, workState, onLabelClick }) => (
	<g id="TrackSBlue" transform="translate(1997.000000, 1066.000000)" className="track">
		<g id="line" transform="translate(0.000000, 0.254415)"
			 stroke={getTrackColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)} strokeLinecap="round"
			 strokeWidth={tracksWidth}
		>
			<line x1="36.2276286" y1="24.2973028" x2="3.90798505e-14" y2="38.7455853"/>
			<path
				d="M167,-4.79616347e-14 L159.71957,7.24194976 C144.526631,22.3545868 122.191858,27.767856 101.765611,21.2882253 L90.8605913,17.8289263 C76.4355006,13.2529873 60.860555,13.8960746 46.8618025,19.6456301 L46.8618025,19.6456301 L46.8618025,19.6456301"/>

			<TrackArrow transform="translate(34.173299, 24.851016) rotate(-200.000000) translate(-34.173299, -24.851016) "
									points="38.1732994 32.8510163 30.1732994 24.8510163 38.1732994 16.8510163"/>
		</g>

		<Label
			onClick={(event, ref) => onLabelClick(event, ref, 'TrackSBlue')}
			coords="72.000000, 3.000000"
			text="S"
			textCoordsX="9.50564236"
			textCoordsY="17.1388889"
			size="small"
			colors={getLabelColorByStateAndDifficulty(state, workState, TRACK_DIFFICULTY_BLUE)}
		/>
	</g>
);

TrackSBlue.propTypes = trackPropTypes;
export default TrackSBlue;
